<template>
	<ion-card color="light">
		<ion-card-header>
			<ion-card-title v-if="form.title">{{ form.title }}</ion-card-title>
			<ion-card-subtitle v-if="subtitle.length > 0 || contributors.length > 0">
				<span v-if="subtitle.length > 0">{{ subtitle }}</span>
				<span v-if="contributors.length > 0">({{ contributors }})</span>
			</ion-card-subtitle>
		</ion-card-header>
		<ion-card-content v-if="form.fields && form.fields.length > 0">
			<ion-chip color="danger" outline="true" v-if="form.pending">
				<ion-icon ios="ios-cloud-upload" md="md-cloud-upload" color="danger"></ion-icon>
				<ion-label color="danger">Pending</ion-label>
			</ion-chip>
			<ion-chip color="medium" outline="true" v-for="reader in form.readers" v-bind:key="reader">
				<ion-icon color="tertiary" ios="ios-eye" md="md-eye"></ion-icon>
				<ion-label color="primary">{{ reader }}</ion-label>
			</ion-chip>
			<ion-chip color="medium" outline="true" v-for="field in form.fields.slice(0, maximum)" v-bind:key="field.id">
				<ion-icon color="tertiary" v-if="field.icon" :ios="'ios-' + field.icon" :md="'md-' + field.icon"></ion-icon>
				<ion-label color="primary" v-if="field">{{ field.title }}</ion-label>
			</ion-chip>
			<ion-chip color="medium" outline="true" v-if="form.fields.length > maximum">
				<ion-label>...</ion-label>
			</ion-chip>
		</ion-card-content>
	</ion-card>
</template>

<script>
import moment from "moment";
import Form from "../models/Form";
import Field from "../models/Field";
export default {
	name: "card-form",
	props: ["form"],
	data() {
		return {
			maximum: 10
		};
	},
	computed: {
		subtitle() {
			let _subtitle = [];
			if (this.form && this.form.description && this.form.description.length > 0) {
				_subtitle.push(this.form.description);
			}
			if (this.form && this.form.updated && this.form.updated.length > 0) {
				_subtitle.push(moment(this.form.updated).fromNow());
			} else if (this.form && this.form.created && this.form.created.length > 0) {
				_subtitle.push(moment(this.form.created).fromNow());
			}
			return _subtitle.join(", ");
		},
		contributors() {
			let _contributors = [];
			for (let writer in this.form.writers) {
				_contributors.push(writer);
			}
			for (let reader in this.form.readers) {
				_contributors.push(reader);
			}
			return _contributors.join(", ");
		}
	}
};
</script>

<style scoped>
ion-card-header {
	margin-bottom: 0px;
	padding-bottom: 0px;
}
ion-card-content {
	padding-top: 5px;
	margin-top: 0px;
}
ion-chip {
	margin-left: 0px;
	margin-right: 8px;
}
</style>